import httpClient from '../../api/httpClient'

export default {
  namespaced: true,
  state: {
    loading: false,
    message: {},
  },

  mutations: {
    SET_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_MESSAGE: (state, message) => {
      state.message = message
    },
  },

  getters: {
    loading: ({ loading }) => loading,
    message: ({ message }) => message,
  },

  actions: {
    async getUserData({ commit }, users) {
      commit('SET_LOADING', true)
      //convert string to array
      const usersAndIds = users.split(',')

      //get user IDs
      const ids = usersAndIds.filter((data) => {
        return !isNaN(data)
      })
      //get usernames
      const usernames = usersAndIds.filter((data) => {
        return isNaN(data)
      })

      //send request
      try {
        await httpClient.post(
          `/admin/influencers/user-data`,
          {
            ids,
            usernames,
          },
        )
        commit('SET_MESSAGE', {
          text: 'added users successfully',
          type: 'success',
        })
      } catch (error) {
        commit('SET_MESSAGE', error)
        commit('SET_MESSAGE', {
          text: error,
          type: 'error',
        })
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async getUserFullData({ commit }, users) {
      commit('SET_LOADING', true)
      //convert string to array
      const usersAndIds = users.split(',')

      //get user IDs
      const ids = usersAndIds.filter((data) => {
        return !isNaN(data)
      })
      //get usernames
      const usernames = usersAndIds.filter((data) => {
        return isNaN(data)
      })

      //send request
      try {
        await httpClient.post(
          `/admin/influencers/user-full-data`,
          {
            ids,
            usernames,
          },
        )
        commit('SET_MESSAGE', {
          text: 'added users successfully',
          type: 'success',
        })
      } catch (error) {
        commit('SET_MESSAGE', error)
        commit('SET_MESSAGE', {
          text: error,
          type: 'error',
        })
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },
}
